var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconUnlocked1 = function SvgIconUnlocked1(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9 18.6667V28L26.275 26L29.65 28V18.6667H22.9ZM37.75 44C35.8825 44 34.2904 43.3498 32.9737 42.0493C31.657 40.7489 30.9991 39.1769 31 37.3333C31 35.4889 31.6584 33.9164 32.9751 32.616C34.2918 31.3156 35.8834 30.6658 37.75 30.6667C39.6175 30.6667 41.2096 31.3169 42.5263 32.6173C43.843 33.9178 44.5009 35.4898 44.5 37.3333C44.5 39.1778 43.8417 40.7502 42.525 42.0507C41.2083 43.3511 39.6166 44.0009 37.75 44ZM36.0625 40.6667L41.4625 37.3333L36.0625 34V40.6667ZM28.3 37.324C28.3 38.2858 28.4521 39.2169 28.7563 40.1173C29.0605 41.0178 29.4709 41.8676 29.9875 42.6667H20.2C19.4575 42.6667 18.8217 42.4053 18.2925 41.8827C17.7633 41.36 17.4991 40.7324 17.5 40V18.6667C17.5 17.9333 17.7646 17.3053 18.2938 16.7827C18.823 16.26 19.4584 15.9991 20.2 16H36.4C37.1425 16 37.7784 16.2613 38.3076 16.784C38.8368 17.3067 39.1009 17.9342 39.1 18.6667V28.0667C38.8732 28.0444 38.6469 28.0276 38.4209 28.016C38.1951 28.0044 37.9687 27.9991 37.7419 28C35.1148 28 32.8846 28.9058 31.0513 30.7173C29.2171 32.528 28.3 34.7302 28.3 37.324Z",
    fill: "url(#paint0_linear_34_3739)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_34_3739",
    x1: -1.47105,
    y1: 30,
    x2: 50.3974,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3499FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A3985"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconUnlocked1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/IconUnlocked1.21f3f6cb5524dd79b4f8fc307f28b8af.blank.svg";